import {
    gsap,
    Cubic,
  } from 'gsap';
  
if ($('.question').length) {
    var questionItems = document.getElementsByClassName('question');
    var questionHeaders = document.getElementsByClassName('question__header');

    for (var i = 0; i < questionHeaders.length; i++) {
      questionHeaders[i].addEventListener('click', function () {
        if (this.parentElement.classList.contains('question--active')) {
          this.parentElement.classList.remove('question--active');
          gsap.to(this.parentElement.getElementsByClassName('question__body')[0], {
            height: 0,
            autoAlpha: 0,
            ease: Cubic.easeInOut,
          });
        } else {
          desactiveAllQuestionItems();
          this.parentElement.classList.add('question--active');
          gsap.to(this.parentElement.getElementsByClassName('question__body')[0], {
            height: 'auto',
            autoAlpha: 1,
            ease: Cubic.easeInOut,
          });
        }
      });
    }
    if ($('.question__header').length) {
      questionHeaders[0].click();
    }
  }

  function desactiveAllQuestionItems() {
    for (var i = 0; i < questionItems.length; i++) {
      questionItems[i].classList.remove('question--active');
      gsap.to(questionItems[i].getElementsByClassName('question__body')[0], {
        height: 0,
        autoAlpha: 0,
        marginTop: 0,
        ease: Cubic.easeInOut,
      });
    }
  }